<template>
  <main class="px-4 pt-4">
    <h1 class="mb-4">
      {{ $t('Profiles') }}
    </h1>
    <user-list
      :data-source="dataSource"
      local-storage="users-grid-storage"
    />
  </main>
</template>

<script>
import UserList from '@/components/UserList';
import createCustomStore from '@/utils/create-custom-store';

export default {
  name: 'UsersGrid',
  components: {
    UserList,
  },
  data: () => ({
    dataSource: createCustomStore('profile/api/users/'),
  }),
};
</script>


<style lang="scss" scoped>
.dx-field-label {
  width: auto;
}
</style>
